import React from 'react'
import { useMedia } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Image from 'components/_new/ui/Image/Image'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import s from './DummyLandscapeMobile.scss'
import messages from './messages'

import birdImage from './images/bird.svg'


const DummyLandscapeMobile = () => {
  const { isDesktop } = useMedia()

  return !isDesktop && (
    <div className={s.wrapper}>
      <WidthContainer className={s.container}>
        <Image src={birdImage} />
        <Box pt="24" pb="24">
          <Text
            message={messages.title}
            size="20-24"
            html
          />
        </Box>
      </WidthContainer>
    </div>
  )
}


export default DummyLandscapeMobile
